/* VESPER reveal — adds .in to .vesper .reveal when in view.
 * The hidden state is gated by html.vesper-ready, which we ONLY add on the live
 * storefront — never in the theme editor — so edits render live (no blank-until-save),
 * and content is never stuck hidden if JS fails. */
(function () {
  var dm = window.Shopify && window.Shopify.designMode;

  function revealIn(scope) {
    var els = (scope || document).querySelectorAll('.vesper .reveal:not(.in)');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('in'); obs.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.top < (window.innerHeight || 800) * 0.94 && r.bottom > 0) el.classList.add('in');
      else io.observe(el);
    });
  }

  function boot() {
    // In the editor, leave everything visible (don't arm the hidden CSS).
    if (dm) return;
    document.documentElement.classList.add('vesper-ready');
    revealIn(document);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  // When a section is added/edited in the theme editor, make sure its content shows.
  document.addEventListener('shopify:section:load', function (e) {
    if (!dm) revealIn(e.target);
    // In design mode nothing is hidden, so no action needed.
  });
})();

/* Cart CTA: "More payment options" collapse toggle (wallets hidden by default).
   Delegated on document because the drawer's cart content arrives via section
   morphing, which never executes inline <script> tags. */
(function () {
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-jaws-morepay]');
    if (!btn) return;
    var panel = document.getElementById(btn.getAttribute('aria-controls'));
    if (!panel) return;
    var open = panel.hasAttribute('hidden');
    if (open) panel.removeAttribute('hidden');
    else panel.setAttribute('hidden', '');
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
  });
})();

/* Collection/grid "Quick add" → open the cart drawer (AJAX) instead of a full-page
   reload. Delegated + bulletproof: any failure falls back to the native form submit. */
(function () {
  if (typeof fetch !== 'function' || typeof FormData !== 'function') return;
  var addUrl = ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'cart/add.js';
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.classList || !form.classList.contains('quick')) return;
    e.preventDefault();
    var btn = form.querySelector('button[type="submit"], .btn');
    var original = btn ? btn.innerHTML : '';
    if (btn) { btn.setAttribute('disabled', ''); btn.textContent = 'Adding…'; }
    var restore = function () { if (btn) { btn.removeAttribute('disabled'); btn.innerHTML = original; } };
    fetch(addUrl, { method: 'POST', headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: new FormData(form) })
      .then(function (r) { if (!r.ok) throw new Error('add-failed'); return r.json(); })
      .then(function (item) {
        document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { resource: item, sourceId: 'jaws-quickadd', data: { source: 'jaws-quickadd' } } }));
        var d = document.querySelector('cart-drawer-component');
        if (d && typeof d.open === 'function') { try { d.open(); } catch (err) {} }
        restore();
      })
      .catch(function () { restore(); form.submit(); });
  });
})();
